/* eslint-disable */
require('./NG_Pattern-01')
require('./NG_Pattern-02')
require('./NG_Pattern-03')
require('./NG_Pattern-04')
require('./NG_Pattern-05')
require('./NG_Pattern-06')
require('./NG_Pattern-07')
require('./NG_Pattern-08')
require('./NG_Pattern-09')
require('./NG_Pattern-10')
require('./NG_Pattern-11')
require('./NG_Pattern-12')
require('./NG_Pattern-13')
require('./NG_Pattern-14')
require('./NG_Pattern-15')
require('./NG_Pattern-16')
require('./NG_Pattern-17')
require('./NG_Pattern-18')
require('./NG_Pattern-19')
require('./NG_Pattern-20')



// WEBPACK FOOTER //
// ./src/components/app-icons/patterns/index.js